import { Base, withMountWhenInView } from '@studiometa/js-toolkit';

/**
 * Typeform class.
 */
export default class Typeform extends withMountWhenInView(Base) {
  /**
   * Config.
   */
  static config = {
    name: 'Typeform',
  };

  static scriptLoader;

  /**
   * Mounted hook.
   */
  async mounted() {
    await this.loadScript();
    this.$terminate();
  }

  /**
   * Load the typeform script once.
   * @returns {Promise<void>}
   */
  async loadScript() {
    if (!Typeform.scriptLoader) {
      Typeform.scriptLoader = new Promise((resolve) => {
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://embed.typeform.com/next/embed.js';
        script.addEventListener('load', resolve);
        this.$el.append(script);
      });
    }

    return Typeform.scriptLoader;
  }
}
